import styled from 'styled-components'

export const ContainerVisuCSV = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    display: flex;
    justify-content: space-between;
  }

  .modal__infos {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 15px;
    div {
      display: flex;
      flex-direction: column;

      label {
        font-size: 12px;
        font-weight: 500;
        color: #7b7b7b;
        padding: 0;
        margin: 0;
      }

      p {
        padding: 0;
        margin: 0;
        line-height: 1.1;
        font-size: 13px;
        font-weight: 600;
      }
    }
  }

  .body__conteudo {
    display: flex;
    overflow: hidden;
    gap: 10px;
    /* ocupa a altura restante para o rodapé de ações ficar sempre visível */
    flex: 1;
    min-height: 0;
  }

  .footer__acoes {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    padding-top: 12px;
    flex-shrink: 0;
  }

  .campo__amostra {
    width: 15%;
    border: 2px solid #d9d9d9;
    overflow-y: auto;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .title {
      font-size: 13px;
      color: #2d3436;
      font-weight: 700;
    }
  }

  .selecionar__amostra {
    padding: 10px;
    width: 95%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s;

    label {
      font-size: 12px;
      font-weight: bold;
      margin: 0;
      padding: 0;
      color: #7b7b7b;
    }

    span {
      font-size: 15px;
      font-weight: bold;
      margin: 0;
      padding: 0;
    }

    p {
      margin: 0;
      padding: 0;
      font-size: 13px;
      color: #7b7b7b;
    }
  }

  .selecionar__amostra:is([data-active='false']):hover {
    transform: scale(1.05);
    transition: 0.2s;
  }

  .selecionar__amostra * {
    cursor: inherit;
  }

  .selecionar__amostra:is([data-active='true']) {
    border-left: 4px solid #5da57d;
    background-color: #f6ffed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 0.5s;
  }

  .circle__selecionada {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 3px solid #d9d9d9;
  }

  .circle__selecionada:is([data-active='true']) {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 3px solid #5da57d;
    background-color: #5da57d;
    transition: 0.5s;
  }

  .selecionar__amostra:is([data-active='true']) label {
    color: #5da57d;
    text-align: center;
    margin: 0;
    padding: 0;
  }

  .detalhes__amostra {
    width: 85%;
    background-color: white;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
    border: 2px solid #d9d9d9;
    border-radius: 10px;

    .header__detalhe {
      display: flex;
      align-items: center;
      gap: 5px;
      padding-bottom: 10px;
    }
  }

  .conteudo__analises {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px 10px;
    overflow-y: auto;
  }
`
